module.exports = __webpack_public_path__ + "img/bp_gift1.38424013.png";